export default "__VITE_PUBLIC_ASSET__78846edd__"